module.exports = __webpack_public_path__ + "static/media/n.31e4dc1e.svg";